/**
 * Route Ids common to every application
 *
 * Defined in COMMON_APP_ROUTES
 *
 * Handled in the AppRouteService
 */
export enum CommonAppRouteId {
    /**
     * The root route for the application
     */
    Root = "ROOT",

    /**
     * The default error page displayed when navigation fails
     */
    Error = "ERROR",

    /**
     * THe error page displayed when a route cannot be found
     */
    NotFound = "NOT_FOUND",
}
